export default "/static/dashboard/build/app/img/v2/92187f18e11cb6fd5db9a83491dca768.png";